import React from 'react';
import { CalendarEvent } from '../../types/ics';
import { EventCard } from './EventCard';
import { isSameDay } from '../../utils/dateUtils';

interface DayViewProps {
  currentDate: Date;
  events: CalendarEvent[];
  onEventClick: (event: CalendarEvent) => void;
}

export const DayView: React.FC<DayViewProps> = ({
  currentDate,
  events,
  onEventClick,
}) => {
  const dayEvents = events.filter(event => isSameDay(event.startDate, currentDate));

  return (
    <div className="space-y-4">
      {dayEvents.length > 0 ? (
        dayEvents.map(event => (
          <button
            key={event.uid}
            onClick={() => onEventClick(event)}
            className="w-full text-left"
          >
            <EventCard event={event} />
          </button>
        ))
      ) : (
        <div className="text-center py-8 text-gray-500">
          No events scheduled for this day
        </div>
      )}
    </div>
  );
};